module.exports = new __parcel__URL__("WhiteboardTeammateDark.718ee45a.svg").toString();